export default __webpack_public_path__ + "static/media/2.5d8d56b7.jpeg";